import { CommonModule } from '@angular/common';

import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import {
  AgrNotificationEmptyModule,
  AgrPageToolbarModule,
  AgrPrimaryActionModule,
} from '@next/core-lib/components';

import { AgrDialogModule } from '@next/core-lib/dialog';
import { AgrNotificationModule } from '@next/core-lib/notification';

import { AgrTableModule } from '@next/core-lib/table';
import { TableV2Module } from '@next/core-lib/table-v2';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { MyAdvertisementsComponent } from './my-advertisements.component';
import { SharedModule } from '../shared/shared.module';

import { ActiveOffersOverviewTableComponent } from './components/active-offers-overview/active-offers-overview-table/active-offers-overview-table.component';
// eslint-disable-next-line max-len
import { ActiveRequestsOverviewTableComponent } from './components/active-requests-overview/active-requests-overview-table/active-requests-overview-table.component';
// eslint-disable-next-line max-len
import { ActiveRequestsSlideInOverviewComponent } from './components/active-requests-slide-in/active-requests-slide-in-overview/active-requests-slide-in-overview.component';
// eslint-disable-next-line max-len
import { ClosedDealsOffersOverviewComponent } from './components/closed-deals-offers-overview/closed-deals-offers-overview/closed-deals-offers-overview.component';
// eslint-disable-next-line max-len
import { ClosedRequestsOverviewTableComponent } from './components/closed-requests-overview/closed-requests-overview-table/closed-requests-overview-table.component';
// eslint-disable-next-line max-len
import { MyAdvertisementsTableHeaderComponent } from './components/my-advertisements-table-headers/my-advertisements-table-header/my-advertisements-table-header.component';

import { MyAdvertisementsEffects } from './store/effects/my-advertisements.effects';
import { myAdvertisementsReducer } from './store/reducers/my-advertisements.reducer';

@NgModule({
  declarations: [
    MyAdvertisementsComponent,
    MyAdvertisementsTableHeaderComponent,
    ActiveOffersOverviewTableComponent,
    ActiveRequestsOverviewTableComponent,
    ClosedDealsOffersOverviewComponent,
    ClosedRequestsOverviewTableComponent,
    ActiveRequestsSlideInOverviewComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    AgrPrimaryActionModule,
    AgrDialogModule,
    MatDialogModule,
    AgrPageToolbarModule,
    AgrNotificationModule,
    MatTabsModule,
    FormsModule,
    MatFormFieldModule,
    MatTableModule,
    AgrTableModule,
    TableV2Module,
    MatTooltipModule,
    MatIconModule,
    AgrNotificationEmptyModule,
  ],
  providers: [
    provideState('myAdvertisementsModule', myAdvertisementsReducer),
    provideEffects([MyAdvertisementsEffects]),
  ],
})
export class MyAdvertisementsModule {}
